import { render, staticRenderFns } from "./Ysxkzwsytx.vue?vue&type=template&id=41ea3e4a&scoped=true&"
import script from "./Ysxkzwsytx.vue?vue&type=script&lang=js&"
export * from "./Ysxkzwsytx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea3e4a",
  null
  
)

export default component.exports